import { Injectable } from '@angular/core';
import {
  Observable, tap, throwError, catchError
} from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private baseUrl = environment.teamSalaryBackendUrl;

  private readonly tokenName = 'team-salary-sso-token';

  constructor(private http: HttpClient) {}

  public verifyIAPAssociation(idToken: string): Observable<any> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${idToken}`);

    const url = `${this.baseUrl}/auth`;
    return this.http.get(url, { headers }).pipe(
      catchError((error) => {
        console.error('HTTP Request Error:', error);

        if (error.error && error.error.message) {
          console.error('Server Error Message:', error.error.message);
        }

        return throwError(() => new Error('An error occurred while verifying IAP association.'));
      })
    );
  }

  public isLoggedIn(): boolean {
    return !!sessionStorage.getItem(this.tokenName);
  }

  public storeToken(token: string): void {
    sessionStorage.setItem(this.tokenName, token);
  }

  public deleteToken(): void {
    sessionStorage.removeItem(this.tokenName);
  }

  public getAccessToken(): string | null {
    return sessionStorage.getItem(this.tokenName);
  }
}
